import { Response } from "@ciaopeople/cp-shatsu/HTTP";
import { PostMessageProxyPromise } from "@ciaopeople/cp-shatsu/RemoteService";
import { ThirdParyClientAuthDataForSignIn } from "../../login/data/LoginData.js";
import { APIClientInterface, Ask1stPartyEmailLoginOperation, MembershipDetails } from "../APIClientInterface.js";
import { RESTAPIEventNames, RESTAPIEventsBaseImpl } from "../RESTAPIEvents.js";
import { EmailLoginAskResponse, FullContent } from "../RESTUserServices.js";
import { DataDeletionInfo } from "../types/AuthDataTypes.js";
import { BookmarkCheckRequest, BookmarkCheckResponse, BookmarkedContentsResponse, BookmarkQueryObj } from "../types/BookmarkingDataTypes.js";

import { MembershipCardData } from "@api-commons/membership/MembershipCardData.js";
import { MembershipType } from "@api-commons/membership/MembershipController.js";
import { MembershipStatusInfo } from "../types/MembershipStatusInfo.js";
import { FollowResponseObject, GroupedResolvedTopicObjs, GroupedTopicObjs, isTopicQueryObjWithFollow, RecommendedCount, RecommendedResponse, TopicFollowCheckRequest, TopicFollowCheckResponse, TopicObj, TopicQueryObj, TopicSubscriptionCheckRequest, TopicSubscriptionCheckResponse, UserActionExtraInfo } from "../types/NotificationDataTypes.js";
import { DeviceOrientedRequest, DeviceUpdateRequestPayload, SubscriptionListResponse } from "../types/SubscriptionTypes.js";
import { Ask1stPartyEmailAuthData, GrantStatusResponseContent, OnLoginResponse, OnUserUpdateData, UserFullInfo } from "../types/UserDataTypes.js";
import { BuyMembershipOptions, MembershipUpsellOptions, OTPVerificationResponse } from "../../sdk/ClientSdkPublicInterface.js";

export class APIClientRemoteImpl extends RESTAPIEventsBaseImpl implements APIClientInterface {

    constructor(private proxy: PostMessageProxyPromise) {
        super();
        this.proxy.register(RESTAPIEventNames.TOPIC_FOLLOW_STATUS_CHANGE, (tfq: any) => {
            if(isTopicQueryObjWithFollow(tfq)) {
                this.triggerTopicFollowStatusChange(tfq);
            }
            return Promise.resolve();
        });
        this.proxy.register(RESTAPIEventNames.ARTICLE_SAVE_STATUS_CHANGE, (tfq: any) => {
            this.triggerArticleSaveStatusChange(tfq);
            return Promise.resolve();
        });
        this.proxy.register(RESTAPIEventNames.DEVICE_SUBSCRIPTION_CHANGE, (tfq: any) => {
            this.triggerDeviceSubscriptionChange(tfq);
            return Promise.resolve();
        });
        this.proxy.register(RESTAPIEventNames.USER_TOPIC_FOLLOW_ACTION, (tfq: any) => {
            if(isTopicQueryObjWithFollow(tfq)) {
                this.triggerUserTopicFollowAction(tfq);
            }
            return Promise.resolve();
        });
        this.proxy.register(RESTAPIEventNames.USER_ARTICLE_SAVE_ACTION, (tfq: any) => {
            this.triggerUserArticleSaveAction(tfq);
            return Promise.resolve();
        });
        this.proxy.register(RESTAPIEventNames.NEWSLETTER_SUBSCRIPTION_STATUS_CHANGE, (nse: any) => {
            this.triggerNewsletterSubscriptionStatusChange(nse);
            return Promise.resolve();
        })
        this.proxy.register(RESTAPIEventNames.USER_NEWSLETTER_SUBSCRIPTION_ACTION, (tfq: any) => {
            this.triggerUserNewsletterSubscribeAction(tfq); 
            return Promise.resolve();
        });
    }  
    verificationWithOTPCode(challenge: string, code: string): Promise<OTPVerificationResponse> {
        return this.proxy.invoke("verificationWithOTPCode", challenge, code);
    }

    
    getMembershipStatusInfo(): Promise<MembershipStatusInfo> {
        return this.proxy.invoke("getMembershipStatusInfo");
    }
    updatePersonalData(upd: OnUserUpdateData): Promise<Response<OnLoginResponse>> {
        return this.proxy.invoke("updatePersonalData", upd);
    }
  
    
    getMe(full_data: boolean): Promise<Response<UserFullInfo>> {
        return this.proxy.invoke("getMe", full_data);
    }

    deletePersonalData(checkField: string): Promise<Response<DataDeletionInfo>> {
        return this.proxy.invoke("deletePersonalData", checkField);
    }
    
    resolve(url: string): Promise<Response<FullContent>> {
        return this.proxy.invoke("resolve", url);
    }
    apiFreeCall(url: string): Promise<Response<any>> {
        return this.proxy.invoke("apiFreeCall", url);
    }
    getSlider(sliderName: string, href?: string): Promise<Response<any>> {
        return this.proxy.invoke("getSlider", sliderName, href);
    }
    checkSavedArticles(checkReq: BookmarkCheckRequest): Promise<Response<BookmarkCheckResponse, any>> {
        return this.proxy.invoke("checkSavedArticles", checkReq);
    }
    bookmark(q: BookmarkQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<BookmarkCheckResponse, any>> {
        return this.proxy.invoke("bookmark", q, extra_info);
    }
    unbookmark(q: BookmarkQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<BookmarkCheckResponse, any>> {
        return this.proxy.invoke("unbookmark", q, extra_info);
    }
    getSavedArticles(): Promise<Response<BookmarkedContentsResponse, any>> {
        return this.proxy.invoke("getSavedArticles");
    }



    updateToken(tok: string): Promise<boolean> {
        return this.proxy.invoke("updateToken", tok);
    }
    testGrant(token: string): Promise<Response<GrantStatusResponseContent>> {
        return this.proxy.invoke("testGrant", token);
    }
    signIn(appToken: string, tpud: ThirdParyClientAuthDataForSignIn): Promise<Response<OnLoginResponse>> {
        return this.proxy.invoke("signIn", appToken, tpud);
    }
    flushToken(): Promise<boolean> {
        return this.proxy.invoke("flushToken");
    }
    follow(queryObj: TopicQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<FollowResponseObject>> {
        return this.proxy.invoke("follow", queryObj, extra_info);
    }
    unfollow(queryObj: TopicQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<FollowResponseObject>> {
        return this.proxy.invoke("unfollow", queryObj, extra_info);
    }

    subscribeNewsletter(queryObj: TopicQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<TopicObj>> {
        return this.proxy.invoke("subscribeNewsletter",queryObj,extra_info);
    }
    unsubscribeNewsletter(queryObj: TopicQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<TopicObj>> {
        return this.proxy.invoke("unsubscribeNewsletter",queryObj,extra_info);
    }
    removeNewsletter(queryObj: TopicQueryObj, extra_info: UserActionExtraInfo | null): Promise<Response<TopicObj>> {
        return this.proxy.invoke("removeNewsletter",queryObj,extra_info);
    }
    listNewsletterSubscriptions(): Promise<Response<TopicObj[]>> {
        return this.proxy.invoke("listNewsletterSubscriptions");
    }
    checkNewsletterSubscriptions(checkReq: TopicSubscriptionCheckRequest): Promise<Response<TopicSubscriptionCheckResponse>> {
        return this.proxy.invoke("checkNewsletterSubscriptions",checkReq);
    }

    checkFollowedTopics(checkReq: TopicFollowCheckRequest): Promise<Response<TopicFollowCheckResponse>> {
        return this.proxy.invoke("checkFollowedTopics", checkReq);
    }
    getUserFollowedTopics(): Promise<Response<GroupedResolvedTopicObjs>> {
        return this.proxy.invoke("getUserFollowedTopics");
    }
    getRecommended(skip: number, limit: number): Promise<Response<RecommendedResponse>> {
        return this.proxy.invoke("getRecommended", skip, limit);
    }
    getRecommendedCount(): Promise<Response<RecommendedCount>> {
        return this.proxy.invoke("getRecommendedCount");
    }
    registerDevice(deviceReq: DeviceUpdateRequestPayload): Promise<Response<SubscriptionListResponse>> {
        return this.proxy.invoke("registerDevice", deviceReq);
    }
    unregisterDevice(deviceReq: DeviceOrientedRequest): Promise<Response<SubscriptionListResponse>> {
        return this.proxy.invoke("unregisterDevice", deviceReq);
    }

    enableDevice(deviceReq: DeviceOrientedRequest): Promise<Response<SubscriptionListResponse>> {
        return this.proxy.invoke("enableDevice", deviceReq);
    }
    disableDevice(deviceReq: DeviceOrientedRequest): Promise<Response<SubscriptionListResponse>> {
        return this.proxy.invoke("disableDevice", deviceReq);
    }
    listDevices(): Promise<Response<SubscriptionListResponse, any>> {
        return this.proxy.invoke("listDevices");
    }
    
    getMyPage(): Promise<Response<any>> {
        return this.proxy.invoke("getMyPage");
    }
    getMyMenu(): Promise<Response<any>> {
        return this.proxy.invoke("getMyMenu");
    }

    resolveFollowedTopics(topics: GroupedTopicObjs): Promise<Response<GroupedResolvedTopicObjs, any>> {
        return this.proxy.invoke("resolveFollowedTopics", topics);
    }

    becomeMember(): Promise<Response<any, any>> {
        return this.proxy.invoke("becomeMember");
    }

    memberInfo(): Promise<Response<any, any>> {
        return this.proxy.invoke("memberInfo");
    }
    
    getMembershipBuyLink(): Promise<string> {
        return this.proxy.invoke("getMembershipBuyLink");
    }

    getMembershipGiftLink(): Promise<string> {
        return this.proxy.invoke("getMembershipGiftLink");
    }

    getRedeemGiftLink(subscriptionId: string, userId: string, checkId: string): Promise<string> {
        return this.proxy.invoke("getRedeemGiftLink", subscriptionId, userId, checkId);
    }

    getMembershipManagementLink(sub: string): Promise<string> {
        return this.proxy.invoke("getMembershipManagementLink", sub);
    }

    getDirectBuyLink(type: MembershipType, options: BuyMembershipOptions = {}): Promise<string> {
        return this.proxy.invoke("getDirectBuyLink", type, options);
    }
    getOrderPaymentLink(order: string, key: string): Promise<string> {
        return this.proxy.invoke("getOrderPaymentLink", order, key);
    }
    getMembershipSwitchLink(redirectUrl?: string): Promise<string> {
        return this.proxy.invoke("getMembershipSwitchLink", redirectUrl);
    }
    getMembershipUpsellLink(options?: MembershipUpsellOptions): Promise<string> {
        return this.proxy.invoke("getMembershipUpsellLink", options);
    }

    getMembershipDetails():Promise<MembershipDetails> {
        return this.proxy.invoke("getMembershipDetails");
    }
    
    hasMembershipAccess(): Promise<boolean> {
        return this.proxy.invoke("hasMembershipAccess");
    }

    getMembershipCardData(): Promise<MembershipCardData> {
        return this.proxy.invoke("getMembershipCardData");
    }
    

    setMembershipCardData(firstName: string, lastName: string):Promise<Response<OnLoginResponse>> {
        return this.proxy.invoke("setMembershipCardData", firstName, lastName);
    }
    generateMembershipCard():Promise<Response<void>> {
        return this.proxy.invoke("generateMembershipCard");
    }

    ask1stPartyEmailLogin(operation: Ask1stPartyEmailLoginOperation, data: Ask1stPartyEmailAuthData): Promise<EmailLoginAskResponse> {
        return this.proxy.invoke("ask1stPartyEmailLogin", operation,data);
    }

    getEventPlatformToken(): Promise<string> {
        return this.proxy.invoke("getEventPlatformToken");
    }

}